import type { ContentBlock } from "@/types";

export default function ScoopBody({ content }: { content: ContentBlock[] }) {
  return (
    <div className="mt-8 space-y-5">
      {content.map((block, i) => {
        if (block.type === "h2") {
          return (
            <h2
              key={i}
              className="pt-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl"
            >
              {block.text}
            </h2>
          );
        }
        if (block.type === "quote") {
          return (
            <blockquote
              key={i}
              className="border-l-4 border-primary-500 bg-background-100 px-5 py-4 font-heading text-base leading-relaxed text-foreground-800 md:text-lg"
            >
              <i className="ri-double-quotes-l mr-1 text-primary-500" aria-hidden="true"></i>
              {block.text}
            </blockquote>
          );
        }
        if (block.type === "list") {
          return (
            <ul key={i} className="space-y-2.5">
              {block.items?.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                  <i className="ri-checkbox-blank-circle-fill mt-2 text-[6px] text-primary-500" aria-hidden="true"></i>
                  {item}
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i} className="text-sm leading-loose text-foreground-700 md:text-base md:leading-loose">
            {block.text}
          </p>
        );
      })}
    </div>
  );
}